{
  "Accessibility Menu": "رسائی مینو",
  "Reset settings": "ترتیبات کو دوبارہ ترتیب دیں",
  "Close": "بند کریں",
  "Content Adjustments": "مواد کی ایڈجسٹمنٹ",
  "Adjust Font Size": "فونٹ کا سائز ایڈجسٹ کریں",
  "Highlight Title": "عنوان نمایاں کریں",
  "Highlight Links": "لنکس نمایاں کریں",
  "Readable Font": "قابل خواندگی فونٹ",
  "Color Adjustments": "رنگ کی ایڈجسٹمنٹ",
  "Dark Contrast": "تاریک برعکس",
  "Light Contrast": "ہلکا برعکس",
  "High Contrast": "اعلی برعکس",
  "High Saturation": "ہائی سیچوریشن",
  "Low Saturation": "لو سیچوریشن",
  "Monochrome": "مونوکروم",
  "Protanopia": "پروٹانوپیا",
  "Deuteranopia": "ڈیوٹرانوپیا",
  "Tritanopia": "ٹرائٹانوپیا",
  "Visual & Navigation Aids": "بصری اور نیوی گیشن امداد",
  "Additional Tools": "اضافی ٹولز",
  "Reading Guide": "مطالعہ کی رہنمائی",
  "Stop Animations": "اینیمیشن روکیں",
  "Big Cursor": "بڑا کرسر",
  "Screen Reader": "اسکرین ریڈر",
  "Hide Images": "تصاویر چھپائیں",
  "Image Tooltips": "تصویر کے ٹول ٹپس",
  "Page Structure": "صفحہ کی ساخت",
  "Super Focus": "سپر فوکس",
  "Magnifier": "میگنیفائر",
  "Increase Font Size": "فونٹ کا سائز بڑھائیں",
  "Decrease Font Size": "فونٹ کا سائز کم کریں",
  "Letter Spacing": "حروف کے درمیان جگہ",
  "Line Height": "لائن کی اونچائی",
  "Font Weight": "فونٹ کا وزن",
  "Dyslexia Font": "ڈسلیکسیا فونٹ",
  "Language": "زبان",
  "Open Accessibility Menu": "رسائی مینو کھولیں",
  "Accessibility Profiles": "رسائی پروفائلز",
  "Seizure Safe Profile": "مرگی کے لیے محفوظ پروفائل",
  "Stops animations and reduces color saturation.": "اینیمیشن روکتا ہے اور رنگ کی شدت کم کرتا ہے۔",
  "Blind Profile": "نابینا پروفائل",
  "Activates the screen reader for auditory navigation.": "سمعی نیوی گیشن کے لیے اسکرین ریڈر کو فعال کرتا ہے۔",
  "Visually Impaired Profile": "بصری معذوری پروفائل",
  "Enhances contrast and readability for low vision.": "کم بینائی کے لیے کنٹراسٹ اور پڑھنے کی صلاحیت کو بہتر بناتا ہے۔",
  "ADHD Friendly Profile": "ADHD دوست پروفائل",
  "Reduces distractions for better focus.": "بہتر توجہ کے لیے خلفشار کم کرتا ہے۔",
  "Cognitive & Learning Profile": "علمی اور تعلیمی پروفائل",
  "Helpful tools for reading and comprehension.": "پڑھنے اور سمجھنے کے لیے مفید ٹولز۔",
  "Motor Impaired Profile": "موٹر معذوری پروفائل",
  "Optimizes the site for keyboard-only navigation.": "صرف کی بورڈ نیوی گیشن کے لیے سائٹ کو بہتر بناتا ہے۔",
  "Headings": "عناوین",
  "Landmarks": "نشانات",
  "Links": "لنکس",
  "Focus element": "عنصر پر فوکس کریں",
  "Visit link": "لنک ملاحظہ کریں"
}